export const principalBrokerDutiesList = [
  `Acting as a liaison or contact person with the Registrar for all matters concerning the 
    operation of the mortgage brokerage, including licensing matters, complaints, inspections, 
    responding to directions, orders, demands, or requirements of the Registrar and annual 
    returns provided to the Registrar under Section 54 of the Act.`,

  `Establishing, maintaining and periodically reviewing policies and procedures for the mortgage 
    brokerage to assist the brokerage and each of its authorized mortgage brokers and authorized 
    associate mortgage brokers in complying with the Act and its regulations.`,

  `Ensuring that each authorized mortgage broker and authorized associate mortgage broker is 
    competent to carry out their duties and responsibilities under the Act and its regulations.`,

  `Ensuring that each authorized associate mortgage broker is adequately supervised.`,

  `Ensuring that regular audits are carried out on the work of the mortgage brokerage and 
    of each authorized mortgage broker and authorized associate mortgage broker, and investigate 
    and respond to any complaints made to the brokerage.`,

  `Advising the Registrar immediately on becoming aware of any contravention of the Act or 
    its regulations by the mortgage brokerage or an authorized mortgage broker or authorized 
    associate mortgage broker.`,

  `Advising the Registrar in writing immediately if any mortgage broker or associate mortgage 
    broker ceases to be authorized to broker mortgages on behalf of the mortgage brokerage.`,

  `Ensuring that the mortgage brokerage immediately notifies the Registrar in writing of any 
    change to a business address or electronic address provided in an application 
    for a licence or licence renewal, as required by Section 21 of the Act.`,

  `Ensuring that the mortgage brokerage notifies the Registrar in writing of any change of 
    circumstances as required by Section 22 of the Act in accordance with, and within the time 
    period prescribed by, the Reporting Requirements Regulations made under the Act.`
];

export const complainceOfficerDutiesList = [
  "I, #AGENT_FULL_NAME#, confirm that I am engaged with the activities with the mortgage lender to the extent I am capable of carrying out my duties and responsibilites as Compliance Officer under the Mortgage Regulation Act and its regulations.",
  "I, #AGENT_FULL_NAME#, confirm that I have read and understand the Mortgage Regulation Act and its regulations and l agree to carry out my duties and responsibilities under the Act and its regulations."
];
